import {
  useEffect,
  useState,
} from "react";
import Calendar from "react-calendar";
import Popup from "reactjs-popup";
import { DataLayerAPI } from "../../../api/DataLayerAPI";

import styles from "./HotelCalendar.module.scss";

type HotelCalendarType = {
    onChange: (date: Date[]) => void;
    dates: Date[];
    isStayLong: (date: Date[]) => boolean;
    formattedDate: string[];
}

const dataLayerAPI = new DataLayerAPI()

export function HotelCalendar({ onChange, dates, formattedDate, isStayLong }:HotelCalendarType) {
    // There's currently a bug with reactjs-popup which means the server-side
    // output will be slightly different to the client-side output, resulting
    // in a warning on the client side.
    // https://github.com/yjose/reactjs-popup/issues/215
    // So here we're using useEffect() to only render the popup on the client side.
    const [open, setOpen] = useState(false);
    const [ isNextMonthRendered, setIsNextMonthRendered ] = useState<boolean>(false);
    const [ isPrevMonthRendered, setIsPrevMonthRendered ] = useState<boolean>(false)

    const calendarNavigationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function() {
            setIsNextMonthRendered(true)
        });
    });

    function observeCalendarNavigation(){
        const monthFrom = document.getElementsByClassName('react-calendar__navigation__label__labelText--from')
        // callback for mutation observer
        if(monthFrom[0]){
            calendarNavigationObserver.observe(monthFrom[0], {
                characterData: true,
                characterDataOldValue:true,
                subtree: true,
                attributeOldValue: true,
            });}
    }

    useEffect(() => {
        const viewContainer = document.getElementsByClassName('react-calendar__viewContainer');
        const prevMonthButton = document.querySelector('[aria-label="previous month"]')
        prevMonthButton?.addEventListener('click',() => setIsPrevMonthRendered(true))
        if (isNextMonthRendered) {
            viewContainer[0].classList.remove('animate-reverse');
            viewContainer[0].classList.add('animate');
            setTimeout(function () {
                viewContainer[0].classList.remove('animate');
            }, 1000);
            setIsNextMonthRendered(false);
        } else if(isPrevMonthRendered){
            viewContainer[0].classList.remove('animate');
            viewContainer[0].classList.add('animate-reverse');
            setTimeout(function () {
                viewContainer[0].classList.remove('animate-reverse')
            }, 1000);
            setIsPrevMonthRendered(false);
        }
    }, [isNextMonthRendered,isPrevMonthRendered])

    let show2Months = true;

    // only show 1 month on mobile if screen height is smaller than 745px
    if (screen.height <= 745) {
      show2Months = false;
      calendarNavigationObserver.disconnect();
    }

    // Date selection text helper function
    const handleFormattingDateText = (date:Date) => {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
      const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const weekday = date.getDay();
      const dayDate = date.getDate();
      const month = date.getMonth();

      return `${weekdays[weekday]} ${dayDate} ${months[month]}`;
    }

    const handleNumOfNights = (startDate:any, endDate:any) => {
      const daysInMS = endDate - startDate; // milliseconds
      const numOfNights = Math.floor(daysInMS / (1000 * 60 * 60 * 24));

      return numOfNights;
    }

  return (
    <div className={styles.buttonSection}>
      <button onClick={() => setOpen(o => !o)} aria-label="open hotel calendar" type='button'>
        {formattedDate.length > 1 ? formattedDate.join(' - ') : 'Add dates'}
      </button>
      <Popup
        open={open}
        closeOnDocumentClick className='hotelsModal'
        onOpen={() => {dataLayerAPI.logModalAction('Modal Opened','Search Form Calendar','Calendar'), observeCalendarNavigation()}}
        onClose={() => {
        dataLayerAPI.logModalAction('Modal Closed','Search Form Calendar','Calendar'),calendarNavigationObserver.disconnect()
        setOpen(false)
        }}>
        {(close: Function) => (
          <div>
            <div className={styles.modal}>
              <div className={styles.calendarContainer}>
                {show2Months && <button className={styles.cancelBtn} onClick={() => close()}>Cancel</button>}
                <Calendar
                  nextAriaLabel="next month"
                  selectRange={true}
                  minDate={new Date()}
                  onChange={onChange}
                  value={[dates[0], dates[1]]}
                  closeCalendar={false}
                  showDoubleView={show2Months}
                  showNeighboringMonth = {false}
                  minDetail='month'
                  maxDetail='month'
                  prevAriaLabel="previous month"
                  className={'calendarCustom'}
                />
                <div className={styles.calendarFooter}>
                  {dates.length > 1
                    &&
                      <div className={styles.dateSelection}>{dates.length > 1 && handleFormattingDateText(dates[0])} - {dates.length > 1 && handleFormattingDateText(dates[1])} ({handleNumOfNights(dates[0], dates[1])} nights)</div>}
                  {isStayLong(dates) ? '' : <p className={styles.error}>You can only book a maximum of 21 nights</p>}
                  <button
                    type="button"
                    disabled={isStayLong(dates) ? false : true}
                    onClick={() => close()}
                    className={styles.btn}>
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Popup>
    </div>
  )
}
